import { Component, ComponentEditDialogState } from ".";
import { InDefCommonFlagType } from "../../../util/general-code/enums/general-codes";

export const componentInitialState: Component = {
  cpntId: "",
  cpntName: "",
  cpntNameWtngChng: "",
  cpntDesc: "",
  gpgEncryptnFlg: InDefCommonFlagType.NO,
  useAssmdRoleFlg: InDefCommonFlagType.NO,
  ediUsgFlg: InDefCommonFlagType.NO,
  useEdhCnvtrFlg: InDefCommonFlagType.NO,
  hubFlg: InDefCommonFlagType.NO,
  updateDateTimeMCpnt: "",
  edhPrtclList: [],
  ifStrtMthdList: [],
  edhNtfctnTypeList: [],
  edhPrtclInfoList: [],
};

export const componentEditDialogInitialState: ComponentEditDialogState = {
  isShow: false,
  isEdit: false,
  isUpdated: false,
  component: componentInitialState,
  formEditData: {
    edhPrtclList: [],
    ifStrtMthdList: [],
    inboundNotificatorList: [],
    outboundNotificatorList: [],
  },
  searchButtonDisabled: false,
  edhProtocolCombination: [],
  dataList: {
    cpntOwnType: [],
    cpntAlctnType: [],
    edhProtcolList: [],
    startMethod: [],
    inboundNotificator: [],
    outboundNotificator: [],
    dynamicEdhProtocolList: [],
  },
  formValidation: {
    cpntNameWtngChng: true,
    cpntDesc: true,
    gpgEncryptnFlg: true,
    useAssmdRoleFlg: true,
    useEdhCnvtrFlg: true,
    hubFlg: true,
    edhPrtclList: true,
    ifStrtMthdList: true,
    inboundNotificatorList: true,
    outboundNotificatorList: true,
    ediUsgFlg: true,
  },
  fieldPath: {
    cpntId: "cpntId",
    cpntName: "cpntName",
    cpntNameWtngChng: "cpntNameWtngChng",
    cpntDesc: "cpntDesc",
    gpgEncryptnFlg: "gpgEncryptnFlg",
    useAssmdRoleFlg: "useAssmdRoleFlg",
    useEdhCnvtrFlg: "useEdhCnvtrFlg",
    hubFlg: "hubFlg",
    edhPrtclList: "edhPrtclList",
    ifStrtMthdList: "ifStrtMthdList",
    edhNtfctnTypeList: "edhNtfctnTypeList",
    ediUsgFlg: "ediUsgFlg",
    updateDateTimeMCpnt: "updateDateTimeMCpnt",
  },
};
